"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _GridList = _interopRequireDefault(require("@material-ui/core/GridList"));

var _GridListTile = _interopRequireDefault(require("@material-ui/core/GridListTile"));

var _GridListTileBar = _interopRequireDefault(require("@material-ui/core/GridListTileBar"));

var _excluded = ["id", "image"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      overflow: "hidden",
      backgroundColor: theme.palette.background.paper
    },
    gridList: {
      width: "100%"
    },
    gridListTileBar: {
      background: "rgba(255, 255, 255, 0.85)"
    },
    tileRoot: {
      background: "white",
      textAlign: "center"
    },
    tile: {
      border: "1px solid lightgrey"
    },
    image: {
      maxWidth: "100%",
      maxHeight: "100%",
      marginLeft: "auto",
      marginRight: "auto"
    }
  };
});
/**
 * const tileData = [
 *   {
 *     id: 1
 *     image: http://...,
 *     ...rest
 *   },
 *   {
 *     [etc...]
 *   },
 * ];
 */

var ImageList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var tileData = _ref.tileData,
      cols = _ref.cols,
      title = _ref.title,
      subtitle = _ref.subtitle,
      onClickItem = _ref.onClickItem;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_GridList["default"], {
    cols: cols,
    className: classes.gridList
  }, tileData && tileData.length > 0 && tileData.map(function (_ref2, idx) {
    var id = _ref2.id,
        image = _ref2.image,
        rest = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/_react["default"].createElement(_GridListTile["default"], {
      classes: {
        root: classes.tileRoot,
        tile: classes.tile
      },
      key: idx // style={{ background: "white", textAlign: "center" }}

    }, /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        return onClickItem(_objectSpread({
          id: id,
          image: image
        }, rest));
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: classes.image,
      src: image,
      alt: id
    })), (title || subtitle) && /*#__PURE__*/_react["default"].createElement(_GridListTileBar["default"], {
      className: classes.gridListTileBar,
      title: title && title(_objectSpread({
        id: id
      }, rest)),
      subtitle: subtitle && subtitle(_objectSpread({
        id: id
      }, rest))
    }));
  }))));
});

var _default = ImageList;
exports["default"] = _default;
ImageList.defaultProps = {
  tileData: [],
  cols: 2,
  title: null,
  subtitle: null,
  onClickItem: null
};
ImageList.propTypes = {
  tileData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    image: _propTypes["default"].string
  })),
  cols: _propTypes["default"].number,
  title: _propTypes["default"].func,
  subtitle: _propTypes["default"].func,
  onClickItem: _propTypes["default"].func
};